import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';
import Image from './Image';

const Avatar = ({ src, width, height, children, displayName, ...props }) => {
  const initials = useMemo(() => {
    if (!displayName) {
      return null;
    }

    const split = displayName.split(' ');
    const first = split[0].slice(0, 1);
    const last = split[1] ? split[1].slice(0, 1) : null;

    return `${first}${last || ''}`;
  }, [displayName]);

  return (
    <Container
      width={width || height || '100px'}
      height={height || width || '100px'}
      borderRadius="100%"
      overflow="hidden"
      backgroundColor="background300"
      {...props}
    >
      <Container height="100%" width="100%">
        {children ||
          (src ? (
            <Image
              objectFit="cover"
              src={src}
              alt="Avatar"
              width="100%"
              height="100%"
            />
          ) : (
            <Container
              width="100%"
              height="100%"
              backgroundImage="linear-gradient(306deg, #6B96F1 0%, #4249FF 100%)"
              color="white"
              fontWeight="bold"
              display="flex"
              alignItems="center"
              justifyContent="center"
              textTransform="uppercase"
            >
              {initials}
            </Container>
          ))}
      </Container>
    </Container>
  );
};

Avatar.propTypes = {
  src: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
  displayName: PropTypes.string,
};

Avatar.defaultProps = {
  src: '',
  children: null,
  width: null,
  height: null,
  displayName: null,
};

export default Avatar;
